import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from './plugins/axios-instance'
import VueAxios from 'vue-axios'

import './scss/main.scss'

Vue.use(VueAxios, axios)

Vue.config.productionTip = false
Vue.prototype.$google = window.google
Vue.prototype.$client = (cb) => window.google.accounts.oauth2.initCodeClient({
  client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  scope: 'https://mail.google.com/ https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/admin.directory.user.readonly https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/presentations.readonly https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
  ux_mode: 'popup',
  access_type: 'offline',
  prompt: 'consent',
  callback: (response) => {
    cb(response.code)
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
